<template>
    <div class="calendar">
        <h6 class="title" @click="handleMonthClick()"
            @contextmenu.prevent="handleMonthContext()">{{date}}</h6>
        <div class="header">
            <div class="week" v-for="item in weekCell" @click="handleWeekClick(item.id)"
                 @contextmenu.prevent="handleWeekContext(item.id)">{{item.name}}
            </div>
        </div>
        <div class="body">
            <div class="col" v-for="(col,index) in dateData" :key="index">
                <div class="row" v-for="row in col">
                    <div @click="handleClick(row)" @contextmenu.prevent="handleContext(row)"
                         :style="{'background':row.color}" class="in-row" :class="{'calendar-ball':row.color!='#fff'}">
                        {{row.day}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "@/store";
    export default {
        data() {
            return {
                weekCell: [
                    {
                        id: 0,
                        name: '周一'
                    },
                    {
                        id: 1,
                        name: '周二'
                    },
                    {
                        id: 2,
                        name: '周三'
                    },
                    {
                        id: 3,
                        name: '周四'
                    },
                    {
                        id: 4,
                        name: '周五'
                    },
                    {
                        id: 5,
                        name: '周六'
                    },
                    {
                        id: 6,
                        name: '周日'
                    }]
            }
        },
        mounted() {

        },
        props: {
            date: ''
        },
        computed: {
            dateData: function () {
                let date = this.date;
                const daysArr = [[], [], [], [], [], []]; // 6*7的日历数组
                const currentWeekday = this.$moment(date).date(1).weekday(); // 获取当月1日为星期几
                const lastMonthDays = this.$moment(date).subtract(1, 'month').daysInMonth(); // 获取上月天数
                const currentMonthDays = this.$moment(date).daysInMonth(); // 获取当月天数
                const getDay = day => (day <= lastMonthDays ? "" : (day <= (lastMonthDays + currentMonthDays)) ? day - lastMonthDays : ""); // 日期处理
                for (let i = 0; i < 7; i += 1) {
                    let virtualDay = (lastMonthDays - currentWeekday) + i + 1;
                    for (let j = 0; j < 6; j += 1) {
                        let day = getDay(virtualDay + (j * 7));
                        let dateK = this.$moment(date + '-' + day).format('YYYY-MM-DD');
                        daysArr[j][i] = {
                            'day': day,
                            'color': (this.$parent.chosenData.hasOwnProperty(dateK)&&day!=='') ? this.$parent.chosenData[dateK].color : '#fff'
                        }
                    }
                }
                return daysArr;
            }
        },
        methods: {
            handleClick(row) {
                if (row.day === "") return;
                let date = this.$moment(this.date + '-' + row.day).format('YYYY-MM-DD');
                this.$set(this.$parent.chosenData, date, {
                    'date': date,
                    'template_day_id': this.$parent.chosenTemplateDay.id,
                    'color': this.$parent.chosenTemplateDay.color,
                })
            },
            handleContext(row) {
                if (row.day === "") return;
                let date = this.$moment(this.date + '-' + row.day).format('YYYY-MM-DD');
                this.$delete(this.$parent.chosenData, date)
            },
            handleWeekClick(id) {
                for (let i = 0; i < 7; i += 1) {
                    if (this.dateData[i]) {
                        if (this.dateData[i][id].day) {
                            let date = this.$moment(this.date + '-' + this.dateData[i][id].day).format('YYYY-MM-DD');
                            this.$set(this.$parent.chosenData, date, {
                                'date': date,
                                'template_day_id': this.$parent.chosenTemplateDay.id,
                                'color': this.$parent.chosenTemplateDay.color,
                            })
                            console.log(date)
                        }
                    }
                }
            },
            handleWeekContext(id) {
                for (let i = 0; i < 7; i += 1) {
                    if (this.dateData[i]) {
                        if (this.dateData[i][id].day) {
                            let date = this.$moment( this.date + '-' + this.dateData[i][id].day).format('YYYY-MM-DD');
                            this.$delete(this.$parent.chosenData, date)
                        }
                    }
                }
            },
            handleMonthClick(){
                for (let i = 0; i < 7; i += 1) {
                    if (this.dateData[i]) {
                        for (let j = 0; j <= 6; j += 1) {
                            if (this.dateData[i][j].day) {
                                let date = this.$moment(this.date + '-' + this.dateData[i][j].day).format('YYYY-MM-DD');
                                this.$set(this.$parent.chosenData, date, {
                                    'date': date,
                                    'template_day_id': this.$parent.chosenTemplateDay.id,
                                    'color': this.$parent.chosenTemplateDay.color,
                                })
                            }
                        }
                    }
                }
            },
            handleMonthContext(){
                for (let i = 0; i < 7; i += 1) {
                    if (this.dateData[i]) {
                        for (let j = 0; j <= 6; j += 1) {
                            if (this.dateData[i][j].day) {
                                let date = this.$moment(this.date + '-' + this.dateData[i][j].day).format('YYYY-MM-DD');
                                this.$delete(this.$parent.chosenData, date)
                            }
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .calendar {

        .title {
            margin-bottom: 5px;
            text-align: center;
        }
        .header {
            display: flex;
            flex-direction: row;
            justify-content: center;
            .week {
                flex: 1;
                padding: 2px 2px;
                width: 30px;
            }
        }
        .body {
            .dark {
                color: #ddd;
                padding: 0 2px;
                height: 17px;
            }
            .calendar-ball {
                color: #fff;
                border-radius: 5px;
                padding: 0 2px;
            }
            display: flex;
            flex-direction: column;
            justify-content: center;
            .col {
                flex: 1;
                display: flex;
                padding: 1px 1px;
                .row {
                    .in-row {
                        height: 17px;
                        text-align: center;
                        width: 30px;
                    }
                    width: 30px;
                    padding: 5px 2px;
                    flex: 1;
                    margin-right: 1px;
                    margin-left: 1px;
                }
            }
        }
    }
</style>
